'use strict';

const SELECTORS = {
    ftoErrorModal: '.js-fto-error-modal'
};

function init() {
    showErrorModal();
}

function showErrorModal() {
    const $ftoErrorModal = $(SELECTORS.ftoErrorModal);
    if ($ftoErrorModal.length) {
        $ftoErrorModal.modal('show');
    }
}

module.exports = {
    init: init
};
